<template>
  <div>
    <div class="cover featured" v-if="hasFbVideos" v-for="video in getFbLatestVideos(0, 1)">
        <img :src="video.thumbnailUrl" class="featured__image"/>
        <div class="featured--wrapper wrapper">
            <h2 class="featured__label">Featured Video</h2>
            <div style="width: 50%">
                <p class="featured__video-date">{{ getFormatedDate(video.createdDate)  }}</p>
                <h1 class="title title--white title--large">{{ video.title }}</h1>
                <p class="featured__description">{{ video.description.substring(0, 100) + (video.description.length > 100 ? "..." : "") }}</p>
                <a style="margin-top: 20px" href="#" class="play-button" @click.prevent="toggleYoutubeVideoPopup(video.id)">Watch Video</a>
            </div>
        </div>
    </div>

   <div class="white-box">
        <div class="wrapper wrapper--spaced">
            <div class="playlist">
                <h1 class="playlist__title title">Latest Videos</h1>
                <ul class="playlist__videos">
                    <li class="playlist__video" v-for="video in getFbLatestVideos(1, 4)">
                        <a href="#" @click.prevent="toggleYoutubeVideoPopup(video.id)">
                            <img :src="video.thumbnailUrl" class="playlist__video-image"/>
                            <p class="playlist__video-date">{{ getFormatedDate(video.createdDate)  }}</p>
                            <h1 class="playlist__video-title">{{ video.title }}</h1>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="playlist">
                <h1 class="playlist__title title">Featured</h1>
                <ul class="playlist__videos">
                    <li class="playlist__video" v-for="video in getFbFeaturedVideos(0, 4)">
                        <a href="#" @click.prevent="toggleYoutubeVideoPopup(video.id)">
                            <img :src="video.thumbnailUrl" class="playlist__video-image"/>
                            <p class="playlist__video-date">{{ getFormatedDate(video.createdDate)  }}</p>
                            <h1 class="playlist__video-title">{{ video.title }}</h1>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
   </div>

   <div id="politicsexplained" class="blue-box blue-box--dark jumbotron" :style="'background-image: linear-gradient(to left, transparent, #071843), url(' + require('@/assets/jumbotron-politics-explained-2.jpg') + '); background-position: 0 20%;'">
        <div class="wrapper wrapper--spaced">
            <img src="@/assets/politics-explained-logo.svg" alt=""/>  
            <div class="jumbotron__content--left">
                <p class="text">With millions of views, Politics Explained is Canada’s hottest political series. From pipelines to gas prices to cancel culture and more, join Aaron as he works to uncover the truth on the issues that matter to Canadians</p>
            </div>
        </div>
   </div>
   <div class="blue-box blue-box--dark jumbotron">
        <div class="wrapper wrapper--spaced">
            <div class="playlist">
                <h1 class="playlist__title playlist__title--white title title--white">Season Three</h1>
                <ul class="playlist__videos playlist__videos--triple">
                    <li class="playlist__video" v-for="video in getFbPolExplainedThreeVideos()">
                        <a href="#" @click.prevent="toggleYoutubeVideoPopup(video.id)">
                            <img :src="video.thumbnailUrl" class="playlist__video-image"/>
                            <h1 class="playlist__video-title">{{ video.title }}</h1>
                        </a>
                    </li>
                </ul>
                <h1 class="playlist__title playlist__title--white title title--white">Season Two</h1>
                <ul class="playlist__videos playlist__videos--triple">
                    <li class="playlist__video" v-for="video in getFbPolExplainedTwoVideos()">
                        <a href="#" @click.prevent="toggleYoutubeVideoPopup(video.id)">
                            <img :src="video.thumbnailUrl" class="playlist__video-image"/>
                            <h1 class="playlist__video-title">{{ video.title }}</h1>
                        </a>
                    </li>
                </ul>
                <h1 class="playlist__title playlist__title--white title title--white">Season One</h1>
                <ul class="playlist__videos playlist__videos--triple">
                    <li class="playlist__video" v-for="video in getFbPolExplainedOneVideos()">
                        <a href="#" @click.prevent="toggleYoutubeVideoPopup(video.id)">
                            <img :src="video.thumbnailUrl" class="playlist__video-image"/>
                            <h1 class="playlist__video-title">{{ video.title }}</h1>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
   </div>
  </div>
</template>

<script>
import videosMixin from '@/videos-mixin.js'
export default {
    mixins: [videosMixin],
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {

    }

}
</script>

<style scoped>
.featured { background: linear-gradient(to bottom, transparent, black); position: relative; overflow: hidden;  }
.featured--wrapper { margin-bottom: 60px; }
.featured__label { width: 100%; padding-bottom: 20px; margin-bottom: 20px; text-transform: uppercase; border-bottom: 1px solid white; color: white;}
.featured__image { position: absolute; z-index: -1; min-width: 100%; min-height: 100%; object-fit: cover; top: 0; left: 0; }
.featured__description { padding-top: 20px; color: white; }
.featured__video-date { margin-top: 10px; margin-bottom: 10px; color: #9F9F9F; font-weight: 300; }

.playlist { margin-bottom: 40px; }
.playlist__title { border-bottom: 1px solid #062573; padding: 10px 0; margin-bottom: 30px; }
.playlist__title--white { border-color: white; color: white; }
.playlist__videos { list-style: none; display: flex; flex-wrap: wrap; margin-left: -30px; }
.playlist__video { flex: 1; padding-left: 30px; margin-bottom: 50px; box-sizing: border-box; }
.playlist__videos--triple .playlist__video { flex: calc(100% / 3) 0; }
.playlist__video-image { width: 100%; height: 170px; object-fit: cover; }
.playlist__video-date { margin-top: 10px; margin-bottom: -5px; color: #9F9F9F; font-weight: 300; }
.playlist__video-title { margin-top: 10px; font-weight: 600; }

@media (max-width: 1100px) {
    .playlist__videos { margin-left: 0; }
    .playlist__video, .playlist__videos--triple .playlist__video { flex: 100% 0; padding-left: 0; }
}

@media (max-width: 768px) {

}

@media (max-width: 526px) {

}


</style>
